import { render } from "./KioskWaitingQueue.vue?vue&type=template&id=5de78143&scoped=true"
import script from "./KioskWaitingQueue.vue?vue&type=script&lang=js"
export * from "./KioskWaitingQueue.vue?vue&type=script&lang=js"

import "./KioskWaitingQueue.vue?vue&type=style&index=0&id=5de78143&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de78143"]])

export default __exports__